// src/pages/GalleryPage.js
import React from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import pastShows from "../data/pastShows";
import galleryData from "../data/galleryData"; // 👈 Import the new gallery data

const GalleryPage = () => {
  const { slug } = useParams();
  const { t } = useTranslation();

  // 👈 Updated Logic: Find show in either pastShows OR galleryData
  const show = pastShows.find((s) => s.slug === slug) || galleryData[slug];

  if (!show) {
    return (
      <main className="page-content">
        <div className="gallery-header">
          <h1>{t("galleryNotFoundTitle")}</h1>
          <p>
            {t("galleryNotFoundText")}{" "}
            <Link to="/contact">{t("galleryNotFoundLink")}</Link>.
          </p>
        </div>
      </main>
    );
  }

  return (
    <main className="page-content">
      <div className="gallery-header">
        <h1>{show.venue}</h1>
        <p>
          {show.city} • {show.date}
        </p>
        <span className="package-badge">{show.packageType}</span>
      </div>
      <div className="photo-grid">
        {show.images.map((image, index) => (
          <div key={index} className="photo-item">
            <img src={image} alt={`${show.venue} gallery photo ${index + 1}`} />
          </div>
        ))}
      </div>
    </main>
  );
};

export default GalleryPage;
